import { withChannelByName, withLogger } from './decorators';
import bizPlugins from './bizPlugins';
var decorators = [withChannelByName, withLogger];
var addDecorators = function addDecorators(plugin) {
  return decorators.reduce(function (decoratorPlugin, decorator) {
    return decorator(decoratorPlugin);
  }, plugin);
};
var plugins = bizPlugins.map(function (plugin) {
  return addDecorators(plugin);
});
export default plugins;